define('router/router-tasks/trial-notifications-task',['require','exports','module','lodash','api-access','api-access','notifications/notification-services','notifications/trial-end-notification/trial-end-notification','notifications/downgrade-notification/downgrade-notification','notifications/trial-ending-non-marvel-notification/trial-ending-non-marvel-notification','notifications/trial-ending-marvel-notification/trial-ending-marvel-notification'],function (require, exports, module) {
    var _ = require('lodash');
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;

    var notificationService = require('notifications/notification-services');
    var EndOfTrialMessage = require('notifications/trial-end-notification/trial-end-notification');
    var DowngradeMessage = require('notifications/downgrade-notification/downgrade-notification');
    var NonMarvel = require('notifications/trial-ending-non-marvel-notification/trial-ending-non-marvel-notification');
    var MarvelMessage = require('notifications/trial-ending-marvel-notification/trial-ending-marvel-notification');

    var showNotifications = function (activeRoute) {
        var notificationDialog;

        // generic modal renderer that accespts a modal constructor
        // and calls show() function on it when the page is ready
        var genericNotifRenderer = function (ModalCtor) {
            // make sure we only show one notification
            if (notificationDialog) {
                return;
            }

            var notif = new ModalCtor();
            notificationDialog = notif.show();
        };

        // render functions for different notification dialogs
        var renderFunctions = {
            'trial-ending-marvel-notification': _.partial(genericNotifRenderer, MarvelMessage),
            'trial-ending-non-marvel-notification': _.partial(genericNotifRenderer, NonMarvel),
            'trial-end-notification': _.partial(genericNotifRenderer, EndOfTrialMessage),
            'downgrade-notification': _.partial(genericNotifRenderer, DowngradeMessage)
        };

        var loadSettings = function () {
            return $.when(
                userApi.settings(),
                commerceApi.getProducts(),
                userApi.tierSettings('g2m'),
                userApi.me()
            )
            .fail(function () {
                // this could happen when the user has no products (ie corporate users)
                // or for a real api call failure
            });
        };

        var renderNotification = function (pending) {
            // for testing only
            // return renderFunctions['downgrade-notification']();

            if (pending && renderFunctions[pending]) {
                renderFunctions[pending]();
            }
        };

        var showCorrectNotification = function () {
            // get some settings to figure out what we need to do
            userApi.me()
                .then(loadSettings)
                .then(notificationService.formatConfigFromApi)
                .then(notificationService.getPendingNotifications)
                .then(renderNotification)
                .fail(function () {
                    // this could happen if the user has no products
                    // console.log('error', err);
                });
        };

        showCorrectNotification(activeRoute);
    };

    module.exports = showNotifications;
});

